"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migratePerStepBackgrounds = void 0;
/**
 * This migration got introduced because now backgrounds need to be defined in each step.
 */
const migratePerStepBackgrounds = async (dialog) => {
    const branch = dialog.scenes.scene1.branches.start;
    // Original background
    const parallax = branch.parallax;
    // Should never get here
    if (!parallax) {
        throw new Error(`Error: Could not find parallax data in 'branch'`);
    }
    const steps = branch.steps;
    Object.values(branch.steps).forEach((step) => {
        if (!step.parallax)
            step.parallax = parallax;
    });
    branch.steps = steps;
    return dialog;
};
exports.migratePerStepBackgrounds = migratePerStepBackgrounds;
//# sourceMappingURL=migratePerStepBackgrounds.js.map